import React from 'react'
import Layout from '../../component/Layout';
import NpmContent from '../../component/NpmContent';
import { t } from 'i18next';

const NPMContainer = () => {
	return (
		<Layout title={t('NPM')} description={t("npm_desc")}>
			<NpmContent />
		</Layout>
	)
}

export default NPMContainer